import { render, staticRenderFns } from "./rt-positioning.vue?vue&type=template&id=3ffa004c&"
import script from "./rt-positioning.vue?vue&type=script&lang=js&"
export * from "./rt-positioning.vue?vue&type=script&lang=js&"
import style0 from "./rt-positioning.vue?vue&type=style&index=0&id=3ffa004c&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports